import { render } from "./AvitoListingsPage.vue?vue&type=template&id=34d85767&scoped=true"
import script from "./AvitoListingsPage.vue?vue&type=script&lang=js"
export * from "./AvitoListingsPage.vue?vue&type=script&lang=js"

import "./AvitoListingsPage.vue?vue&type=style&index=0&id=34d85767&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d85767"]])

export default __exports__